import { render } from "./DomainShop.vue?vue&type=template&id=07f40cac"
import script from "./DomainShop.vue?vue&type=script&lang=js"
export * from "./DomainShop.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__